export class CountDownOptions {
	public constructor(
		public isDaysDisplayed: boolean,
		public isHoursDisplayed: boolean,
		public isMinutesDisplayed: boolean,
		public isSecondsDisplayed: boolean
	) {}
}
